import { BrowserRouter, Route, Switch } from "react-router-dom";
import Page404 from "./pages/Page404/404";
import DashboardCustomization from "./pages/university/DashboardCustomization";
import Home from "./pages/university/Home";
import ListAndCreateWhitelabel from "./pages/university/listAndCreateWhitelabel/ListAndCreateWhitelabel";
import { Talk } from "./pages/university/Talk";
import { EventDashboard } from "./pages/event/dashboard";
import Group from "./pages/university/Group";
import { VideoConference } from "./pages/videoConference";
import FormRegister from "../src/pages/videoConference/form";
import Watch from "./pages/videoConference/watch";

const Routes = () => {
  return (
    <BrowserRouter>
      <Route
        render={({ location }) => (
          <Switch location={location}>
            <Route

              exact
              path={"/welcome"}
              component={() => <ListAndCreateWhitelabel />}
            />
            <Route
              exact
              path={"/:kind/formulario"}
              component={() => <FormRegister playback={location.search}/>}
            />
            <Route
              exact
              path={"/:kind/assista"}
              component={() => <Watch />}
            />
            <Route
              exact
              path={"/list-white-labels"}
              component={() => <ListAndCreateWhitelabel />}
            />
            <Route
              path={"/:channel/conference-dashboard-customization"}
              component={() => <VideoConference />}
            />
            <Route
              exact
              path={"/:channel/dashboard-customization"}
              component={() => <DashboardCustomization />}
            />
            <Route
              exact
              path={"/:channel/event-dashboard-customization"}
              component={() => <EventDashboard />}
            />
            <Route
              path={"/:channel/groups/:groupSlug"}
              component={() => <Group />}
            />
            <Route
              exact
              path={"/:channel"}
              component={() => <Home />}
              key={"/"}
            />
            <Route
              exact
              path={"/:channel/:talkSlug"}
              component={() => <Talk />}
              key={"/"}
            />
            <Route component={() => <Page404 />} />
          </Switch>
        )}
      />
    </BrowserRouter>
  );
};

export default Routes;
